import { ApiError } from "@nabble/sdk";
import { errorMessage } from "../errors";

/** Messages for a failed passkey ceremony: one for the server's answer, one for the browser's (canceled, unsupported). */
export interface PasskeyErrorMessages {
  server: string;
  browser: string;
}

export function passkeyErrorMessage(err: unknown, messages: PasskeyErrorMessages): string {
  return err instanceof ApiError ? errorMessage(err, messages.server) : messages.browser;
}
